var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    fill: "#202124",
    stroke: "#494949",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 11.4072C21.1365 11.6123 20.6383 11.7502 20.1152 11.8135C20.6479 11.4935 21.0595 10.9895 21.2519 10.3878C20.7518 10.6829 20.1979 10.8975 19.6093 11.0125C19.1381 10.5124 18.4668 10.2 17.7225 10.2C16.2953 10.2 15.1375 11.3536 15.1375 12.7754C15.1375 12.9766 15.1606 13.174 15.2048 13.3618C13.0564 13.2545 11.1523 12.2274 9.87706 10.6695C9.65395 11.0508 9.527 11.4935 9.527 11.9668C9.527 12.8597 9.98284 13.6473 10.6772 14.1091C10.2521 14.0957 9.85398 13.9807 9.50585 13.7872C9.50585 13.7987 9.50585 13.8082 9.50585 13.8197C9.50585 15.0672 10.3964 16.1077 11.5792 16.3453C11.3619 16.4047 11.1349 16.4354 10.8984 16.4354C10.731 16.4354 10.5695 16.42 10.4118 16.3894C10.7407 17.4107 11.6946 18.158 12.8256 18.1772C11.9428 18.869 10.8272 19.279 9.61548 19.279C9.40583 19.279 9.20195 19.2675 9 19.2445C10.1425 19.9746 11.5023 20.4 12.9621 20.4C17.7167 20.4 20.3171 16.4756 20.3171 13.0743C20.3171 12.9613 20.3152 12.8501 20.3094 12.739C20.8153 12.3787 21.2538 11.9246 21.6 11.4072Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fb4d214ebdbd968fdace37be8455dc4b.svg";
export { ForwardRef as ReactComponent };